import Parse from 'parse';

export const addNewSecurityGuard = (data) => {
  return Parse.Cloud.run('addNewSecurityGuard', data);
};
